import {get} from '@shared/helpers/object'

import {BankCodeType, FinancialInvestmentCompanyCodeType, PaymentsCardCodeType} from '@web/core/constants'

/** 결제 가능한 카드사 목록에 따라 카드를 필터링 합니다 */
export function filterCardCode<T>({
    prop,
    cards,
    availableAll,
    availableCardCodes,
}: {
    prop: keyof T
    cards: T[]
    availableAll: boolean
    // 가능 카드사 코드 목록
    availableCardCodes: string[]
}) {
    if (!availableAll) {
        const hasAvailableCardCode = (cardCode: PaymentsCardCodeType) => availableCardCodes.includes(cardCode)
        return cards.filter((card) => {
            const code: PaymentsCardCodeType = get(prop, card)
            return !!code && hasAvailableCardCode(code)
        })
    }
    return cards
}

/** string 을 PaymentsCardCodeType로 변환 (타입 단언) */
export function toPaymentsCardCode(cardCode: string): PaymentsCardCodeType {
    return cardCode as PaymentsCardCodeType
}

/** string 배열을 PaymentsCardCodeType 배열로 안전하게 변환 */
export function toPaymentsCardCodeTypes(cardCodes: Maybe<string[]>): PaymentsCardCodeType[] {
    if (!cardCodes) {
        return []
    }
    return cardCodes.map(toPaymentsCardCode)
}

export function toBankOrFinancialCompanyCodeType(code: string): BankCodeType | FinancialInvestmentCompanyCodeType {
    return code as BankCodeType | FinancialInvestmentCompanyCodeType
}
